import { Card, CardBody, Col } from "reactstrap";
import { P } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BorderBottomTitle } from "../../../../Constants/Constants";
import { BorderBottomSubTitle } from "../../../../Data/BonusUi/CreativeCard";

const BorderBottom = () => {
  return (
    <Col md="6" xs="12">
      <Card>
        <CommonCardHeader title={BorderBottomTitle} span={BorderBottomSubTitle} headClass="border-b-info" />
        <CardBody>
          <P className="mb-0">
            {"A navigation bar is a particularly important feature because it allows visitors to quickly and easily find"}
            <em className="txt-danger">{" important pages on your website "}</em>
            {", like your blog, product pages, pricing, contact info, and documentation. This improves the chances of visitors browsing your site longer, which can boost your page views and reduce your bounce rate."}
          </P>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BorderBottom;
